<template>
  <div class="home-skeleton">
    <div class="item" v-for="i in 2" :key="i" :style="{ backgroundColor: bg }">
      <shSkeleton bg="#e4e4e4" width="195px" height="120px" animated />
      <shSkeleton bg="#e4e4e4" width="185px" height="24px" animated />
      <shSkeleton bg="#e4e4e4" width="90px" height="24px" animated />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  width: 400px;
  height: 210px;
  display: flex;
  justify-content: space-between;
  .item {
    width: 195px;
    height: 210px;
    .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 16px auto 0;
    }
  }
}
</style>
